import { useTranslation } from "react-i18next";
import React from "react";

import { StyledBuilderContainer } from "../../components/MattressBuilder/MattressBuilderContainer";
import { useDispatch, useSelector } from "react-redux";
import BedSizeSelector from "./BedSizeSelector/BedSizeSelector";
import SingleBedBuilder from "./SingleBedBuilder/SingleBedBuilder";
import SleeperName from "./SleeperName";
import DoubleBedBuilder from "./DoubleBedBuilder/DoubleBedBuilder";
import { isSingleSleeperSelector } from "../../redux/slices/mattressConfiguration";
import {
  currentStackSelector,
  currentStepDoubleSleeperMattressBuilderSelector,
  currentStepGeneralSelector,
  currentStepSingleSleeperMattressBuilderSelector,
} from "../../redux/slices/customNavigation";

const MattressBuilderWizard = () => {
  const dispatch = useDispatch();
  const isSingleSleeper = useSelector(isSingleSleeperSelector);
  const currentStack = useSelector(currentStackSelector);
  const currentStepGeneral = useSelector(currentStepGeneralSelector);
  const currentStepSingleSleeperMattressBuilder = useSelector(
    currentStepSingleSleeperMattressBuilderSelector
  );
  const currentStepDoubleSleeperMattressBuilder = useSelector(
    currentStepDoubleSleeperMattressBuilderSelector
  );
  const { t } = useTranslation();
  const generalSteps = [
    {
      component: () => <BedSizeSelector></BedSizeSelector>,
    },
    {
      component: () => <SleeperName></SleeperName>,
    },
  ];
  const singleSleeperSteps = [
    { component: () => <SingleBedBuilder></SingleBedBuilder> },
  ];
  const doubleSleeperSteps = [];

  const GeneralComponent = generalSteps[currentStepGeneral]?.component;
  const SingleSleeperComponent =
    singleSleeperSteps[currentStepSingleSleeperMattressBuilder]?.component;
  const DoubleSleeperComponent =
    doubleSleeperSteps[currentStepDoubleSleeperMattressBuilder]?.component;
  return (
    <StyledBuilderContainer className="styled-builder-container" style={{height: "100vh"}}>
      {currentStack === "general" && <GeneralComponent></GeneralComponent>}

      {currentStack === "singleSleeper" && (
        <SingleBedBuilder></SingleBedBuilder>
      )}
      {currentStack === "doubleSleeper" && (
        <DoubleBedBuilder></DoubleBedBuilder>
      )}
    </StyledBuilderContainer>
  );
};

export default MattressBuilderWizard;
